import styled, { css, keyframes } from "styled-components";
import { theme } from "../../../constants/StyledComponents";

export const spinAnim = keyframes`
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
`;

export const StyledWrapper = styled.div<{
  $hasChildren: boolean;
  $fullscreen?: boolean;
}>`
  position: ${({ $fullscreen: fullscreen, $hasChildren }) =>
    fullscreen ? "fixed" : $hasChildren ? "relative" : "unset"};

  ${({ $fullscreen: fullscreen }) =>
    fullscreen &&
    css`
      inset: 0;
      z-index: 50;
      display: flex;
      align-items: center;
      justify-content: center;
    `}
`;

export const StyledOverlay = styled.div<{
  $hasChildren: boolean;
  $fullscreen?: boolean;
}>`
  position: ${({ $fullscreen: fullscreen, $hasChildren }) =>
    fullscreen || $hasChildren ? "absolute" : "unset"};
  inset: 0;
  z-index: 10;
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${({ $fullscreen: fullscreen }) =>
    fullscreen ? "rgba(0, 0, 0, 0.4)" : "rgba(255, 255, 255, 0.3)"};
  border-radius: ${({ $fullscreen: fullscreen }) =>
    fullscreen ? "unset" : theme.variables.border_radius_3};

  & > span > svg {
    color: ${theme.colors.purple};
  }
`;

export const StyledContent = styled.div<{
  $spinning?: boolean;
  $fullscreen?: boolean;
}>`
  ${({ $spinning, $fullscreen }) =>
    $spinning &&
    !$fullscreen &&
    css`
      opacity: 0.4;
    `}
`;

export const StyledDefaultIndicator = styled.span<{ $size?: number }>`
  display: inline-block;
  border-radius: 50%;
  border: 3px solid ${theme.colors.purple};
  border-top-color: transparent;
  animation: ${spinAnim} 1s linear infinite;
  color: ${theme.colors.purple};
  ${({ $size: size }) =>
    size &&
    css`
      width: ${size}px;
      height: ${size}px;
    `};
`;
